import { IonContent } from '@ionic/react';
import styled from "styled-components";

export const MainIonContent = styled(IonContent)`
  h2{
    text-align: center;
  }
`;